(function () {
	const dir = document.querySelector('html').getAttribute("dir");
	let nextEl = ".product-button-group .swiper-button-next";
	let prevEl = ".product-button-group .swiper-button-prev";
	if (dir === 'rtl') {
		[nextEl, prevEl] = [prevEl, nextEl];
	}

	const initSliderOn = (slider) => {
		if (!slider || slider.dataset.swiperInitialized === 'true') return;
		if (typeof Swiper === 'undefined') return;

		try {
			new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: false,
				},
			});
			slider.dataset.swiperInitialized = 'true';
		} catch (e) {
			console.warn('SISA: Swiper init failed on card', e);
		}
	};

	const initAllSliders = (root) => {
		const scope = root && root.querySelectorAll ? root : document;
		const sliders = scope.querySelectorAll('.product-card-js');
		sliders.forEach((slider) => initSliderOn(slider));
	};

	// 1) Inicial
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initAllSliders(document));
	} else {
		initAllSliders(document);
	}

	// 2) Editor de temas (comportamiento original)
	document.addEventListener('shopify:section:load', function (event) {
		initAllSliders(event.target || document);
	});

	// 3) Evento personalizado opcional (por si luego queremos dispararlo desde load-more)
	document.addEventListener('sisa:products-loaded', function (event) {
		const target = (event && event.detail && event.detail.container) || document;
		initAllSliders(target);
	});

	// 4) Red de seguridad: detecta productos nuevos inyectados por scroll infinito / load more
	const startObserver = () => {
		if (!('MutationObserver' in window)) return;

		const observer = new MutationObserver((mutations) => {
			for (const m of mutations) {
				if (m.type !== 'childList') continue;
				m.addedNodes.forEach((node) => {
					if (node.nodeType !== 1) return;
					if (node.matches && node.matches('.product-card-js')) {
						initSliderOn(node);
					}
					if (node.querySelectorAll) {
						node.querySelectorAll('.product-card-js').forEach((s) => initSliderOn(s));
					}
				});
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', startObserver);
	} else {
		startObserver();
	}
})();